console.log("Loading command.js");

window.excelCommandService = null;

// Receive the .NET object reference
function setExcelCommandService(reference) {
    window.excelCommandService = reference;
    console.log("window.excelCommandService reference received.");
}

// Wait until both Office and Blazor are fully ready
async function waitUntilReady() {
    while (!(officeReady && window.authenticationService?.invokeMethodAsync)) {
        await new Promise((resolve) => setTimeout(resolve, 200));
    }
}

/**
 * Renders the page that allows users to select or define a service endpoint. 
 * @param {any} event
 */
async function loginPopup(event) {
    try {
        await waitUntilReady();

        if (await window.authenticationService.invokeMethodAsync("serviceEndpointAllowsUpdateAsync")) {
            await popup("select-service", 15, 20, "handleLoginMessage");
        }
    } catch (err) {
        console.log("Error call : " + err.message);
    } finally {
        event.completed();
    }
}

/**
 * Renders the page that allows users to select or define a service endpoint, forcing B2C authentication. 
 * @param {any} event
 */
async function loginPopupB2C(event) {
    try {
        if (await window.authenticationService.invokeMethodAsync("allowServiceEndpointUpdateAsync", "B2C")) {
            await popup("select-service?authentication=B2C", 15, 20, "handleLoginMessage");
        }
    } catch (err) {
        console.log("Error call : " + err.message);
    } finally {
        event.completed();
    }
}

/**
 * Opens the side panel
 * @param event {Office.AddinCommands.Event}
 */
async function openTaskpane(event) {
    console.log("Open task pane button pressed");
    Office.addin.showAsTaskpane()
    event.completed();
}
Office.actions.associate("openTaskpane", openTaskpane);

/**
 * Clears the request / response cache.
 * @param event {Office.AddinCommands.Event}
 */
function clearCache(event) {

    console.log("clearCache");
    try {
        window.excelCommandService.invokeMethod("clearCache");
    } catch (err) {
        console.log("Error call : " + err.message);
    } finally {
        event.completed();
    }
}
Office.actions.associate("clearCache", clearCache);

/**
 * Saves the request / response cache.
 * @param event {Office.AddinCommands.Event}
 */
async function saveCache(event) {
    console.log("saveCache");
    try {
        await window.excelCommandService.invokeMethod("saveCache");
    } catch (err) {
        console.log("Error call : " + err.message);
    } finally {
        event.completed();
    }
}
Office.actions.associate("saveCache", saveCache);

/**
 * Force recalculates the workbook.
 * @param event {Office.AddinCommands.Event}
 */
async function recalculate(event) {

    console.log("recalculate");
    try {
        //let message = await OfficeRuntime.auth.getAccessToken({ scopes: ["User.Read"], allowSignInPrompt: true, forceRefresh: true });
        await Excel.run(async (context) => {
            context.workbook.application.calculate("Full");
            await context.sync();
        });
    } catch (err) {
        console.log("Error call : " + err.message);
    }
    finally {
        event.completed();
    }
}
Office.actions.associate("recalculate", recalculate);

/**
 * Writes the event source id to the document when ExecuteFunction runs.
 * @param event {Office.AddinCommands.Event}
 */
async function writeValue(event) {

    console.log("In writeValue");

    try {
        let message = "ExecuteFunction2 works. Button ID=" + event.source.id;
        //let message = await OfficeRuntime.auth.getAccessToken({ scopes: ["User.Read"], allowSignInPrompt: true, forceRefresh: true });
        await Excel.run(async (context) => {
            const range = context.workbook.getSelectedRange();
            range.values = [[message]];
            range.getEntireColumn().format.autofitColumns();
            await context.sync();
        });

        console.log("writeValue Succeeded");

    } catch (err) {
        await Excel.run(async (context) => {
            const range = context.workbook.getSelectedRange();
            const cellRange = range.getCell(0, 0);
            cellRange.values = [[err.message]];
            await context.sync();
        });
        console.log();
        console.log("Error call : " + err.message);
    }
    finally {
        console.log("Finish callStaticLocalComponentMethodinit");
        event.completed();
    }
}

// Associate the functions with their named counterparts in the manifest XML.
Office.actions.associate("writeValue", writeValue);

window.downloadFile = (fileName, bytes) => {
    const blob = new Blob([new Uint8Array(bytes)], { type: "application/zip" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

/**
 * Logs in to the LemonEdge system.
 * @param event {Office.AddinCommands.Event}
 */
async function logout(event) {
    try {
        console.log("logout");
        await window.excelCommandService.invokeMethodAsync("logout");
    } catch (err) {
        console.log("Error call : " + err.message);
    } finally {
        event.completed();
    }
}
Office.actions.associate("logout", logout);

async function refreshLoginButtons(loginEnabled, logoutEnabled) {
    Office.ribbon.requestUpdate({
        tabs: [
            {
                id: "LemonEdge.Tab",
                groups: [
                    {
                        id: "LemonEdge.Grp.Access",
                        controls: [
                            {
                                id: "LemonEdge.Btn.LogIn",
                                enabled: loginEnabled
                            },
                            {
                                id: "LemonEdge.Btn.LogOut",
                                enabled: logoutEnabled
                            }
                        ]
                    }
                ]
            }
        ]
    });
}


/**
 * Shows the task pane on the registered query tasks list.
 * The add-in runs a shared runtime, so every task pane control points at the same page - the pane is
 * shown and the Blazor app is then navigated to the list, rather than opening a second task pane.
 * @param event {Office.AddinCommands.Event}
 */
async function showQueryTasks(event) {
    console.log("showQueryTasks");
    try {
        await Office.addin.showAsTaskpane();
        await window.excelCommandService.invokeMethodAsync("showQueryTasks");
    } catch (err) {
        console.log("Error call : " + err.message);
    } finally {
        event.completed();
    }
}
Office.actions.associate("showQueryTasks", showQueryTasks);

/**
 * Shows the task pane on the support/home page.
 * ExecuteFunction rather than ShowTaskpane: with a shared runtime the pane is already loaded, so
 * ShowTaskpane only reveals the existing webview and leaves the Blazor router on whatever page it was
 * last navigated to. Showing and then navigating makes the button land on the same page every time.
 * @param event {Office.AddinCommands.Event}
 */
async function showSupportPanel(event) {
    console.log("showSupportPanel");
    try {
        await Office.addin.showAsTaskpane();
        await window.excelCommandService.invokeMethodAsync("showSupportPanel");
    } catch (err) {
        console.log("Error call : " + err.message);
    } finally {
        event.completed();
    }
}
Office.actions.associate("showSupportPanel", showSupportPanel);
